import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
export const getCategory = createAsyncThunk(
  "get/category",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("categoryList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error: error.message });
      rejectWithValue(error);
    }
  }
);
export const addCategory = createAsyncThunk(
  "add/category",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addCategory", payload);
      return response.data;
    } catch (error) {
      console.log({ error: error.message });
      rejectWithValue(error);
    }
  }
);
export const editCategory = createAsyncThunk(
  "edit/category",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editCategory", payload);
      return response.data;
    } catch (error) {
      console.log({ error: error.message });
      rejectWithValue(error);
    }
  }
);
export const categoryStatusChanged = createAsyncThunk(
  "statusChanged/category",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        "categoryStatusChanged",
        payload
      );
      return response.data;
    } catch (error) {
      console.log({ error: error.message });
      rejectWithValue(error);
    }
  }
);
const categoryManagement = createSlice({
  name: "categoryManagement",
  initialState: {
    loading: false,
    category: [],
  },
  extraReducers: (builder) => {
    builder.addCase(getCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.category = action.payload;
    });
    builder.addCase(getCategory.rejected, (state, action) => {
      state.loading = false;
      console.log("Error in getCategory:", action.error);
    });
  },
});

export default categoryManagement.reducer;
